import { FormUserTerms } from '../../form/compositions/FormUserTerms';
import { FramedContent } from '../../framed-content';

const UserTermsForm = (props: any) => {
  if (
    !props.flowData ||
    !props.flowData?.itemData?.termsAccepted
  ) {
    props.setNextStepDisabled(true);
  } else {
    props.setNextStepDisabled(false);
  }
  return (
    <FramedContent display="flex" alignItems="center" height="100%">
      <FormUserTerms
        formData={props.flowData}
        headline={'Updates auf Medtec Online!'}
        subtitle={'Im Zuge der Bereitstellung der Sharepoints in den Communities und der ausgebauten Bot-Funktionalität auf Medtec Online haben wir unsere Nutzungsbedingungen aktualisiert.'}
        subtitle2={'Bitte bestätigen Sie die aktualisierten Nutzungsbedingungen um das Portal weiter nutzen zu können.'}
        onChange={formData => {
          props.flowFunctions.setFlowData({ ...props.flowData, ...formData });
        }}
      />
    </FramedContent>
  );
};

export default UserTermsForm;
